"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textualBalance = void 0;
/**
 * Converts the visualBalance percentage attribute to the other side of the spectrum (textual).
 * E.g: visual balance is 30%, so the textual balance will be 70%
 *      visual balance is 51%, so the textual balance will be 49%
 *      visual balance is 5%, so the textual balance will be 99%
 *      visual balance is 100%, so the textual balance will be 0%
 * @param blockInfo
 */
var textualBalance = function (blockInfo) {
    return blockInfo.visualBalance
        ? (100 - blockInfo.visualBalance)
        : undefined;
};
exports.textualBalance = textualBalance;
